//http://statsapi.mlb.com/api/v1/teams?fields=teams,id,teamName&sportId=1 to get updated list

const clubDict = [
    {
        id: 133,
        teamName: 'Athletics'
    },
    {
        id: 134,
        teamName: 'Pirates'
    },
    {
        id: 135,
        teamName: 'Padres'
    },
    {
        id: 136,
        teamName: 'Mariners'
    },
    {
        id: 137,
        teamName: 'Giants'
    },
    {
        id: 138,
        teamName: 'Cardinals'
    },
    {
        id: 139,
        teamName: 'Rays'
    },
    {
        id: 140,
        teamName: 'Rangers'
    },
    {
        id: 141,
        teamName: 'Blue Jays'
    },
    {
        id: 142,
        teamName: 'Twins'
    },
    {
        id: 143,
        teamName: 'Phillies'
    },
    {
        id: 144,
        teamName: 'Braves'
    },
    {
        id: 145,
        teamName: 'White Sox'
    },
    {
        id: 146,
        teamName: 'Marlins'
    },
    {
        id: 147,
        teamName: 'Yankees'
    },
    {
        id: 158,
        teamName: 'Brewers'
    },
    {
        id: 108,
        teamName: 'Angels'
    },
    {
        id: 109,
        teamName: 'D-backs'
    },
    {
        id: 110,
        teamName: 'Orioles'
    },
    {
        id: 111,
        teamName: 'Red Sox'
    },
    {
        id: 112,
        teamName: 'Cubs'
    },
    {
        id: 113,
        teamName: 'Reds'
    },
    {
        id: 114,
        teamName: 'Indians'
    },
    {
        id: 115,
        teamName: 'Rockies'
    },
    {
        id: 116,
        teamName: 'Tigers'
    },
    {
        id: 117,
        teamName: 'Astros'
    },
    {
        id: 118,
        teamName: 'Royals'
    },
    {
        id: 119,
        teamName: 'Dodgers'
    },
    {
        id: 120,
        teamName: 'Nationals'
    },
    {
        id: 121,
        teamName: 'Mets'
    }
];

export default clubDict;
